import React from 'react'
import styled from 'styled-components'
import ButtonShell from 'components/elements/ButtonShell'

const StyledButton = styled.span`
  display: block;
  min-width: 140px;
  text-align: center;
  & > a,
  & > button {
    font-family: ${(props) => props.theme.font.family.secondary};
    border: 1px solid ${(props) => props.theme.color.text.contrast};
    color: #353535
    font-size: ${(props) => props.theme.font.size.base};
    font-weight: 400;
    text-transform: uppercase;
    padding: 12px 15px;
    width: 100%;
    height: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    cursor: pointer;
    border-radius: 5px;

    & .button-outline__arrow {
      flex-shrink: 0;
    }

    &:hover {
      color: ${(props) => props.theme.color.text.light};
      background-color: ${(props) => props.theme.color.text.contrast};
      border-color: ${(props) => props.theme.color.text.contrast};
    }
  }
`

function ButtonOutlineArrowIcon() {
  return (
    <svg
      className="button-outline__arrow"
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="9"
      viewBox="0 0 14 9"
      fill="none"
      aria-hidden
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.9292 4.45854C13.9292 4.185 13.689 3.96313 13.3933 3.96313L0.535877 3.96313C0.240119 3.96313 0.000235558 4.185 0.000235558 4.45854C0.000235558 4.73208 0.240371 4.95412 0.535877 4.95412L13.3933 4.95412C13.689 4.95412 13.9292 4.73208 13.9292 4.45854Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.48648 8.77319L13.7724 4.80941C13.9814 4.61611 13.9814 4.30199 13.7724 4.10875L9.48648 0.144973C9.27754 -0.0483242 8.9379 -0.0483242 8.72891 0.144973C8.51997 0.338211 8.51997 0.65234 8.72891 0.845579L12.6355 4.45853L8.72796 8.07165C8.624 8.16873 8.57152 8.29555 8.57152 8.42253C8.57152 8.54935 8.624 8.6761 8.72891 8.77319C8.93809 8.96642 9.27754 8.96642 9.48648 8.77319Z"
        fill="currentColor"
      />
    </svg>
  )
}

interface ButtonOutlineProps {
  isAnchor?: boolean
  isCustom?: boolean
  to: string
  children: any
  className?: string
  target?: string
  rel?: string
}

function ButtonOutline({
  isAnchor = false,
  isCustom = false,
  to,
  children,
  className = '',
  target,
  rel,
}: ButtonOutlineProps) {
  return (
    <StyledButton className={className}>
      {isCustom ? (
        children
      ) : (
        <ButtonShell to={to} isAnchor={isAnchor} target={target} rel={rel}>
          {children}
          <ButtonOutlineArrowIcon />
        </ButtonShell>
      )}
    </StyledButton>
  )
}

export default ButtonOutline
